import { render, staticRenderFns } from "./GuidedChoiceScreens.vue?vue&type=template&id=1b21a3aa&scoped=true&"
import script from "./GuidedChoiceScreens.vue?vue&type=script&lang=js&"
export * from "./GuidedChoiceScreens.vue?vue&type=script&lang=js&"
import style0 from "./GuidedChoiceScreens.vue?vue&type=style&index=0&id=1b21a3aa&scoped=true&lang=css&"
import style1 from "./GuidedChoiceScreens.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b21a3aa",
  null
  
)

export default component.exports